import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  padding-top: var(--spacing-xxxx-large);
  padding-bottom: var(--spacing-large);
  background-color: #f7f7f7;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  margin-right: var(--spacing-x-large);
  margin-left: var(--spacing-x-large);
`;

export const FooterGrid = styled.div``;

export const CopyrightContainer = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  justify-content: space-between;
  background-color: transparent;
  flex-direction: column;

  color: var(--black);
  font-size: var(--font-size-small);
  line-height: var(--font-line-height-copy);
  font-weight: var(--font-weight-bold);
  padding-bottom: var(--spacing-large);
  margin-top: var(--spacing-large);
`;

export const FooterLinks = styled.div`
  text-align: center;
  color: #333;
  font-size: var(--font-size-copy);
  line-height: var(--font-line-height-copy);
`;

export const FooterHeading = styled.h4`
  margin-bottom: 0;
  line-height: 25px;

  font-size: 13px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: var(--black-opacity50);
  font-weight: var(--font-weight-medium);
`;
export const FooterHeadingText = styled.span``;

export const Link = styled.a`
  text-align: center;
  box-sizing: border-box;
  background-color: transparent;
  display: block;
  margin-top: 10px;
  text-decoration: none;

  color: var(--purple);
  font-size: var(--font-size-copy);
  line-height: var(--font-line-height-large);
  font-weight: var(--font-weight-medium);
`;

export const CopyRightLink = styled.a`
  box-sizing: border-box;
  background-color: transparent;
  text-decoration: none;
  font-size: 10px;
  outline: 0;

  color: var(--grey);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-copy);
`;

export const Divider = styled.div`
  color: #333;
  box-sizing: border-box;
  width: 100%;
  height: 1px;

  background-color: var(--blue);
  margin-top: var(--spacing-large);
  margin-bottom: var(--spacing-large);
  font-size: var(--font-size-copy);
  line-height: var(--font-line-height-copy);
`;

export const CopyrightLinksContainer = styled.div`
  box-sizing: border-box;
  font-size: 10px;
  margin-bottom: 10px;

  font-weight: var(--font-weight-medium);
  color: var(--black-opacity90);
  line-height: var(--font-line-height-copy);
`;

export const CompanyName = styled.div`
  box-sizing: border-box;
  color: #818181;
  font-size: 10px;

  font-weight: var(--font-weight-medium);
  background-attachment: scroll;
  line-height: var(--font-line-height-copy);
`;
